export const APPLIED_GIFT_CARDS_FRAGMENT = `
  fragment APPLIED_GIFT_CARDS_FRAGMENT on AppliedGiftCard {
    __typename
    code
    applied_balance {
      value
      currency
    }
    current_balance {
      value
      currency
    }
    expiration_date
  }
`;

export const GIFT_MESSAGE_FRAGMENT = `
  fragment GIFT_MESSAGE_FRAGMENT on GiftMessage {
    __typename
    from
    to
    message
  }
`;

export const GIFT_WRAPPING_FRAGMENT = `
  fragment GIFT_WRAPPING_FRAGMENT on GiftWrapping {
    __typename
    uid
    design
    image {
      url
    }
    price {
      value
      currency
    }
  }
`;

export const AVAILABLE_GIFT_WRAPPING_FRAGMENT = `
  fragment AVAILABLE_GIFT_WRAPPING_FRAGMENT on GiftWrapping {
   __typename
   uid
   design
   image {
     url
     label
   }
   price {
     currency
     value
   }
  }
`;

